"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _CustomPropTypes = _interopRequireDefault(require("../utils/CustomPropTypes"));
var _Button = _interopRequireDefault(require("../Buttons/Button"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _constants = require("../utils/constants");
var _Popper = require("../utils/_Popper");
var _PopoverBase = _interopRequireDefault(require("./_PopoverBase"));
var _QuickHelp = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./QuickHelp.css") : void 0);
var _excluded = ["className", "iconProps", "message", "textClose", "textShowQuickHelp", "title", "placement", "popoverProps", "size"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var CSS_BLOCK = 'sapcnqr-quick-help';

/**
 * **QuickHelp** components are specialized **Popover** components attached to “?” icons.
 * Unlike **Popover** components, **QuickHelp** components display text, not arbitrary content.
 */

var QuickHelp = function QuickHelp(_props) {
  var _context;
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(QuickHelp, _props)) : _props;
  var className = props.className,
    iconProps = props.iconProps,
    message = props.message,
    textClose = props.textClose,
    textShowQuickHelp = props.textShowQuickHelp,
    title = props.title,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? ['bottom', 'top', 'left', 'right'] : _props$placement,
    popoverProps = props.popoverProps,
    _props$size = props.size,
    size = _props$size === void 0 ? 'lg' : _props$size,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var classnames = _bind.default.bind(_QuickHelp.default);
  var classes = classnames(_constants.CSS_PREFIX, CSS_BLOCK, className, (0, _concat.default)(_context = "".concat(CSS_BLOCK, "--")).call(_context, size));
  var iconPath1Classes = classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__icon-path1"));
  var targetClassName = classnames(_constants.CSS_PREFIX, "".concat(CSS_BLOCK, "__target"));
  return /*#__PURE__*/_react.default.createElement(_PopoverBase.default, (0, _extends2.default)({
    placement: placement
  }, popoverProps, {
    message: message,
    targetClassName: targetClassName,
    textClose: textClose,
    title: title
  }), /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, otherProps, {
    "aria-label": textShowQuickHelp,
    className: classes,
    size: size,
    type: "link"
  }), /*#__PURE__*/_react.default.createElement(_Icon.default, (0, _extends2.default)({
    iconName: "messaging-help"
  }, iconProps, {
    ariaHidden: true,
    path1ClassName: iconPath1Classes
  }))));
};
QuickHelp.displayName = 'QuickHelp';
QuickHelp.propTypes = {
  /** Collection of React components to be placed in the **Popover**
   * component's content area. */
  message: _propTypes.default.node.isRequired,
  /** Localized assistive text for the **Popover** component's close button. */
  textClose: _CustomPropTypes.default.localizedString('CoreUIComponents.close').isRequired,
  /** Localized assistive text for the show quick help (“?”)
   * button and the button’s title attribute. Use this prop to convey information
   * to a screen-reader user to provide context when needed if the button is associated with a
   * form control */
  textShowQuickHelp: _CustomPropTypes.default.localizedString('CoreUIComponents.showQuickHelp').isRequired,
  /** **Popover** heading. */
  title: _propTypes.default.string.isRequired,
  /** Custom classes to add to the `<button>` element. */
  className: _propTypes.default.string,
  /** Additional props to be spread to the **Icon**. */
  iconProps: _propTypes.default.object,
  /** Placement of the **Popover** relative to its icon. Options are 'top', 'top-start',
   * 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end',
   * 'right', 'right-start', 'right-end'. */
  placement: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOf(_Popper.POPPER_PLACEMENTS)), _propTypes.default.oneOf(_Popper.POPPER_PLACEMENTS)]),
  /** Properties to pass through to the **Popover**. */
  popoverProps: _propTypes.default.object,
  /** Size of the icon. Options are 'lg' and 'md'. */
  size: _propTypes.default.oneOf(_constants.CONTROL_SIZES)
};
var _default = exports.default = QuickHelp;